module.exports = __webpack_public_path__ + "06_medium_brown.ae706d5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_medium_brown.png
// module id = lT7J
// module chunks = 0